import { Avatar, Badge, Box, Stack, SxProps, Tooltip, Typography } from "@mui/material";
import { FC, useState, useEffect } from "react";
import DoneIcon from "@mui/icons-material/Done";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import UpdateIcon from "@mui/icons-material/Update";
import ActivityHeadingTitle, { ActivtyHeadingTitleColor } from "./activity-heading-title";
import { ActivityVariant } from "../activity";
import moment from "moment";
import AvatarProfilePicture from "../../Misc/AvatarProfilePicture/avatar-profile-picture";
import GlobalConst from "../../../Core/Utils/Constants/globals";

export interface ActivityHeadingProps {
  variant: ActivityVariant;
  label: string;
  action?: string;
  userInitials: string;
  userName: string;
  date?: Date;
  isRead: boolean;
  linkToResource?: string;
  userId: number | null;
  sx?: SxProps;
}

const BadgeBackground: any = {
  success: "success.alpha",
  warning: "warning.alpha",
  error: "error.alpha",
  info: "info.alpha",
  primary: "backgroundAlpha.main",
};

const ColorIcon: any = {
  success: "success.main",
  warning: "warning.main",
  error: "error.main",
  info: "info.main",
  primary: "text.secondary",
};

const Icon: any = {
  success: <DoneIcon fontSize="small" />,
  warning: <ErrorOutlineRoundedIcon fontSize="small" />,
  error: <CancelOutlinedIcon fontSize="small" />,
  primary: <DoneIcon fontSize="small" />,
  info: <UpdateIcon fontSize="small" />,
};

const ActivityHeading: FC<ActivityHeadingProps> = (props) => {
  const { label, action, variant, userName, userInitials, isRead, date, linkToResource, userId, ...sx } = props;
  const [dateFrom, setDateFrom] = useState<string>(moment(moment.utc(date).local().format()).fromNow(true));

  useEffect(() => {
    const timer = setInterval(() => setDateFrom(moment(moment.utc(date).local().format()).fromNow(true)), 30000);

    return function cleanup() {
      clearInterval(timer);
    };
  });

  return (
    <Stack spacing={1.5} direction="row" alignItems="center" {...sx}>
      {variant === "secondary" ? (
        <AvatarProfilePicture userId={userId ?? undefined} userInitials={userInitials} />
      ) : (
        <Avatar
          sx={{
            width: 36,
            height: 36,
            backgroundColor: BadgeBackground[variant],
            color: ColorIcon[variant],
          }}
        >
          {Icon[variant]}
        </Avatar>
      )}

      <Box sx={{ flexGrow: 1 }}>
        <ActivityHeadingTitle
          user={userName}
          label={label}
          action={action}
          variant={variant}
          linkToResource={linkToResource}
        />
      </Box>
      {!isRead && <Badge color="primary" variant="dot" sx={{}} />}
      <Tooltip arrow title={moment(date).format(GlobalConst.MOMENT_DATE_FORMAT_FULL)}>
        <Typography variant="body2" fontWeight={500} color="text.tier">
          {dateFrom}
        </Typography>
      </Tooltip>
    </Stack>
  );
};

export default ActivityHeading;
